/**
 * =============================================================================
 * ROASTBREW - DRIVE PAGE (Content Only)
 * =============================================================================
 *
 * File storage and document management interface.
 * Renders within AppLayout (sidebar handled by parent).
 *
 * =============================================================================
 */

import React from 'react';
import { useTheme } from './ThemeContext';

// Deploy marker — logs once when this bundle loads. Update the timestamp on edits.
console.log('[DrivePage] build 2026-06-15 5:19');


export default function DrivePage({
  isMobile = false,
  isTablet = false,
  isDesktop = true,
  sidebarOpen = true,
}) {
  const { colors, isLight } = useTheme();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
        maxWidth: '100%',
        padding: isMobile ? '80px 16px 80px' : isTablet ? '80px 32px 80px' : '0 48px',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <div style={{ width: '100%', maxWidth: '720px', textAlign: 'center' }}>
        <div style={{
          width: '72px', height: '72px', borderRadius: '20px',
          background: isLight ? 'rgba(26,26,26,0.04)' : `${colors.accent}10`,
          border: `1px solid ${isLight ? 'rgba(0,0,0,0.06)' : `${colors.accent}20`}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 24px',
          animation: 'fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
        }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={colors.accent} strokeWidth="1.5">
            <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2v11z" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h1 style={{
          fontSize: isMobile ? '32px' : '42px', fontWeight: '300', color: colors.text,
          marginBottom: '12px', letterSpacing: '-0.02em',
          fontFamily: '"Cormorant Garamond", serif',
          animation: 'fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.05s both',
        }}>
          Drive
        </h1>

        <p style={{
          fontSize: '16px', color: colors.muted, fontFamily: '"DM Sans", sans-serif',
          lineHeight: 1.6, maxWidth: '480px', margin: '0 auto',
          animation: 'fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.1s both',
        }}>
          Your files, documents, and shared resources will appear here.
        </p>

        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '8px',
          padding: '10px 20px', marginTop: '32px',
          background: isLight ? 'rgba(26,26,26,0.04)' : `${colors.accent}10`,
          border: `1px solid ${isLight ? 'rgba(0,0,0,0.06)' : `${colors.accent}20`}`,
          borderRadius: '24px', fontSize: '13px', fontWeight: '500',
          color: colors.muted, fontFamily: '"DM Sans", sans-serif', letterSpacing: '0.04em',
          animation: 'fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.15s both',
        }}>
          <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: colors.accent }} />
          Coming Soon
        </div>
      </div>
    </div>
  );
}
